import { Fragment } from 'react'
import RecentArticles from '../RecentArticles'
import ContentGroups from '../ContentGroups'
import RecentActivityMap from '../RecentActivityMap'
import EPAnalysis from '../EPAnalysis'
import { Section, Container, H3, Body1, CodeDisplay } from '../../cdl-react-components/components'

const digestStyleGuideFeatures = () => {
    return (
        <Fragment>
            <Section id="style-guide__features__recent-articles">
                <Container>
                    <H3>Recent Articles</H3>
                    <Body1></Body1>
                    <RecentArticles />
                    <br />
                    <CodeDisplay html={`<RecentArticles />`} />
                </Container>
            </Section>
            <Section id="style-guide__features__recent-activity-map">
                <Container>
                    <H3>Recent Activity Map</H3>
                    <Body1></Body1>
                    <RecentActivityMap />
                    <br />
                    <CodeDisplay html={`<RecentActivityMap />`} />
                </Container>
            </Section>
            <Section id="style-guide__features__content-groups">
                <Container>
                    <H3>Content Groups</H3>
                    <Body1></Body1>
                    <ContentGroups />
                    <br />
                    <CodeDisplay html={`<ContentGroups />`} />
                </Container>
            </Section>
            <Section id="style-guide__features__ep-analysis">
                <Container>
                    <H3>E&amp;P Analysis</H3>
                    <Body1></Body1>
                    <EPAnalysis />
                    <br />
                    <CodeDisplay html={`<EPAnalysis />`} />
                </Container>
            </Section>
        </Fragment>
    )
}

export default digestStyleGuideFeatures